import React, { useEffect } from 'react'
import './Passengers.css'


import plane_left from '../../../assets/images/Frame_237.png'
import plane_right from '../../../assets/images/Frame_238.png'

import { useDispatch, useSelector } from 'react-redux'

import { getPassengers } from '../../../actions/passengers.action'

import { Link } from 'react-router-dom'
import { Translate } from '../../Translate/Translate'
import i18next from 'i18next'
import { API_URI } from '../../../axios'
import PageHeader from '../../page-header/PageHeader'
import { useTranslation } from 'react-i18next'


const Passenger = ({ visible }) => {

    const dispatch = useDispatch()
    const language = i18next.language

    useEffect(() => {
        dispatch(getPassengers(language))
    }, [language])

    const passengers_s = useSelector(state => state.passengers)

    const passengers = passengers_s.passengers
    const {t} = useTranslation()

    const { results } = passengers

    const handle_delete = (e) => {
        if (e.length > 10) {
            return e.substring(0, 10) + "..."
        } else {
            return e.substring(0, 10)
        }
    }

    return (
        <>
            {
                results ? <div className="" id="passenger">
                    <PageHeader
                        title={t("passengers")}
                        breadCrumbItems={[
                            { label: t("home"), path: '/' },
                            { label: t("passengers"), path: '#' }
                        ]}
                    />
                    <div className="container py-12">
                        
                        <div className="benefits-one__right">
                            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-3">
                                {
                                    results.map(item => (
                                        <>
                                        {item.route_type === "id" ?
                                        <Link to={`/passengers/${item.id}`} className="col item" key={item.id}>
                                        <div className="benefits-one__single w-100 h-100">
                                            <div className="benefits-one__content">
                                                <div className="benefits-one__icon">
                                                    <img src={`${API_URI}${item.icon}`} alt="" className='w-[50%] h-[160px]  object-contain' />
                                                </div>
                                                <div className="benefits-one__title">
                                                    <h3>{item.title}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </Link> :
                                    <Link to={`/passengers/${item.slug}`} className="col item" key={item.id}>
                                    <div className="benefits-one__single w-100 h-100">
                                        <div className="benefits-one__content">
                                            <div className="benefits-one__icon">
                                                <img src={`${API_URI}${item.icon}`} alt="" className='w-[50%] h-[160px]  object-contain' />
                                            </div>
                                            <div className="benefits-one__title">
                                                <h3>{item.title}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </Link> }
                                        </>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div> : null
            }
        </>
    )
}

export default Passenger